import _ from 'lodash';
import Tone from 'tone/build/Tone';

export class Player {
    //state = {noteinText : ""};

    constructor(swaras) {
        this.kaalam = 2;
        this.swaras = swaras;
        this.synth = new Tone.FMSynth({
            modulation: {
                type: "sine"
            }
        }).toMaster();
        //this.state.noteinText = "";
        Tone.Transport.bpm.value = 80;
    }

    stop() {

        this.synth.unsync();
        Tone.Transport.stop();
        this.synth.triggerRelease();
        console.log('Playing stopped');
    }
    play(notes) {

        this.synth.unsync();
        Tone.Transport.stop();
        this.synth.sync();
        let bpmVal = Tone.Transport.bpm.value;
        console.log(Tone.Transport.bpm.value);
        console.log(notes);
        for (var count = 0; count < notes.length; count++) {
            if (notes[count] === ",") { continue; }
            let restNotes = notes.slice(count + 1, notes.length);
            let commas = _.takeWhile(restNotes, (val) => val === ",")
            let commaLength = commas.length;
            let playTime = `${bpmVal * (1 + commaLength)*0.6*this.kaalam}i`;
            let objOfSwara = this.swaras.find((n) => n.swara == notes[count] || n.altSwara == notes[count]);
            console.log(notes[count]);
            console.log(objOfSwara);
            //swaras["m."] will evaluate to corresponding western note
            //swaras[count].swara.note 
            //this.synth.triggerAttackRelease(swaras[notes[count]], playTime, `${count*bpmVal}i`);
            this.synth.triggerAttackRelease(objOfSwara.note, playTime, `${count * bpmVal*this.kaalam}i`);

        }
        Tone.Transport.start();
    }
    /* //Earlier we were checking the notes as we presented a puzzle
    check(notes, answer){
        console.log(notes);
        if(JSON.stringify(answer) === JSON.stringify(notes)){
            return "correct";
        }
        else{
            return `Wrong. Answer is ${notes}. But you have given answer as ${answer}`;

        }
    }*/
}